import { observer } from "src/shared/util/Observer";
import { bonusCascadeParser, bonusSpinParser, cascadeParser, initGenerator, spinParser } from "./DataParser";
import { IGameServer, InitialResponse, SpinResponse } from "src/shared/util/Types";

/**
 * SignalR Client for Sweet Bonanza Game Service
 */
export class EngineMock implements IGameServer {
    /**
     * Connect to the SignalR service
     * @returns {Promise<void>} - Resolves when the connection is established
     */
    public async connect(): Promise<void> {
    }

    /**
     * Disconnect from the SignalR service
     */
    public async disconnect(): Promise<void> {
    }

    public async getInitialState(): Promise<any> {
        observer.publish('init');
    }

    /**
     * Invoke the GameAction method to perform actions (Spin, BonusSpin, etc.)
     * @param {string} actionType - The type of action (e.g., Spin, SpinAvalanche)
     * @param {object} spinData - The spin data (if applicable)
     * @returns {Promise<any>} - The response from the server
     */
    public async gameAction(actionType: string, spinData?: object): Promise<any> {
        observer.publish(actionType, spinData);
    }

    /**
     * Listen to events from the SignalR service
     * @param {string} eventName - The name of the event to listen for
     * @param {Function} callback - The callback function to handle the event
     */
    public on(eventName: string, callback: (data: any) => void): void {
        this.on(eventName, callback);
    }

    /**
     * Stop listening to a specific event
     * @param {string} eventName - The name of the event to stop listening for
     */
    public off(eventName: string): void {
        this.off(eventName);
    }
    /**
     * Listen specifically for the `initialstateresult` event
     * @param {Function} callback - The callback function to handle the event
     */
    public onInitialStateResult(callback: (data: InitialResponse) => void): void {
        observer.on('init', () => {
            setTimeout(() => {
                const response: InitialResponse = initGenerator();
                callback(response);
            }, 50);
        });
    }

    /**
     * Listen specifically for the `gameactionresult` event
     * @param {Function} callback - The callback function to handle the event
     */
    public onGameActionResult(callback: (data: SpinResponse) => void): void {
        observer.on('Spin', (spinData) => {
            setTimeout(() => {
                console.log("SPIN DATA IS ");
                console.log(spinData);
                const response: SpinResponse = spinParser(spinData);
                callback(response);
            }, 50);
        });
        observer.on('SpinAvalanche', () => {
            setTimeout(() => {
                const response: SpinResponse = cascadeParser();
                callback(response);
            }, 50);
        });
        observer.on('BonusSpin', () => {
            setTimeout(() => {
                const response: SpinResponse = bonusSpinParser();
                callback(response);
            }, 50);
        });
        observer.on('BonusSpinAvalanche', () => {
            setTimeout(() => {
                const response: SpinResponse = bonusCascadeParser();
                callback(response);
            }, 50);
        });
    }
}
